import { Folder, Tag, X } from 'lucide-react';

type Item = { id: number; name: string; slug: string };

interface BlogFiltersProps {
  categories: Item[];
  tags: Item[];
  activeCategory: string;
  activeTag: string;
  onSelectCategory: (slug: string) => void;
  onSelectTag: (slug: string) => void;
  onClear: () => void;
}

export default function BlogFilters({
  categories,
  tags,
  activeCategory,
  activeTag,
  onSelectCategory,
  onSelectTag,
  onClear,
}: BlogFiltersProps) {
  const hasFilter = Boolean(activeCategory || activeTag);

  return (
    <div className="space-y-6">
      {hasFilter && (
        <button
          onClick={onClear}
          className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
          Limpar filtros
        </button>
      )}

      <div className="bg-[#0a1a2e] border border-white/10 rounded-xl p-6">
        <div className="flex items-center gap-2 mb-4">
          <Folder className="w-5 h-5 text-blue-400" />
          <h3 className="text-lg font-semibold">Categorias</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => {
            const isActive = activeCategory === cat.slug;
            return (
              <button
                key={cat.id}
                onClick={() => onSelectCategory(cat.slug)}
                className={`px-3 py-1 text-sm rounded-full border transition-colors ${
                  isActive
                    ? 'bg-blue-500/30 border-blue-400/60 text-blue-100'
                    : 'bg-blue-500/10 border-blue-500/30 text-blue-200 hover:bg-blue-500/20'
                }`}
              >
                {cat.name}
              </button>
            );
          })}
        </div>
      </div>

      <div className="bg-[#0a1a2e] border border-white/10 rounded-xl p-6">
        <div className="flex items-center gap-2 mb-4">
          <Tag className="w-5 h-5 text-green-400" />
          <h3 className="text-lg font-semibold">Tags</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => {
            const isActive = activeTag === tag.slug;
            return (
              <button
                key={tag.id}
                onClick={() => onSelectTag(tag.slug)}
                className={`px-3 py-1 text-sm rounded-full border transition-colors ${
                  isActive
                    ? 'bg-green-500/30 border-green-400/60 text-green-100'
                    : 'bg-green-500/10 border-green-500/30 text-green-200 hover:bg-green-500/20'
                }`}
              >
                {tag.name}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
